import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@blueprintjs/core'
import { AnimatedButton } from 'client/components/AnimatedButton/AnimatedButton'
import { Card, CardType } from 'client/components/Card/Card'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { useClaimController } from 'client/controllers/claimController'
import Logo from 'images/svg/logo.svg'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const CtaBlock: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.PostPage)
  const { setIsOpen } = useClaimController()

  return (
    <ResponsiveBlock size="wide" type="primary">
      <div className="flex w-full flex-col gap-8 pt-12 md:pt-20 lg:gap-20">
        <Card type={CardType.Blue} className="gap-8 p-8 md:px-20 md:py-30">
          <div className="flex w-full items-center justify-between gap-8 max-md:flex-col">
            <div className="flex w-full max-md:justify-center xl:w-8/12">
              <div className="flex flex-col flex-wrap gap-3 max-md:items-center">
                <Text
                  tagName="span"
                  className="font-secondary-regular---22pt text-text-white lg:font-secondary-regular---36pt"
                >
                  {t('cta_block.title')}
                </Text>
                <div className="flex w-60 md:w-72">
                  <img src={Logo} className="w-full object-contain" />
                </div>
              </div>
            </div>
            <div className="flex max-md:w-full max-md:justify-center">
              <AnimatedButton onClick={() => setIsOpen(true)} noBorder>
                {t('cta_block.button')}
              </AnimatedButton>
            </div>
          </div>
        </Card>
      </div>
    </ResponsiveBlock>
  )
}

export { CtaBlock }
